import Server from '../../libs/server'
import { setLocalStorage, getLocalStorage } from '../../libs/storage'

const apis = {
  sendSms: [ '/sms/code/send', 'get' ],
  login: [ '/user/login/examination', 'post' ],
  update: [ '/user/update', 'post' ],
  checkStatus: [ '/user/login/check', 'get' ]
}

export default {
  namespaced: true,

  state: {
    userInfo: getLocalStorage('exam_userInfo', null)
  },
  mutations: {
    setUserInfo (state, userInfo) { state.userInfo = userInfo }
  },
  actions: {
    async sendSms (store, mobile) {
      const [ url, method ] = apis.sendSms
      await Server({
        url,
        method,
        data: { mobile, appName: 'vocational_education' }
      })
    },

    async checkStatus (store, ignoreCode) {
      const [ url, method ] = apis.checkStatus
      const res = await Server({
        url,
        method,
        ignoreCode
      })
      return res
    },

    async login ({ commit }, { mobile, code }) {
      const [ url, method ] = apis.login
      const { data } = await Server({
        url,
        method,
        data: { mobile, code }
      })
      const { userInfo, authorize } = data
      setLocalStorage('exam_userId', userInfo.userId)
      setLocalStorage('exam_userInfo', userInfo)
      setLocalStorage('exam_token', authorize.token)
      setLocalStorage('exam_expiration', authorize.expiration)
      commit('setUserInfo', userInfo)
    },

    async updateUser ({ commit }, info) {
      const [ url, method ] = apis.update
      const { data } = await Server({
        url,
        method,
        data: { info }
      })
      setLocalStorage('exam_userInfo', data)
      commit('setUserInfo', data)
    }
  }
}
